var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"w-max-content text-white"},[_c('a',{staticClass:"p-0 limitador font-13",attrs:{"href":"javascript:;"},on:{"click":_vm.pesquisar}},[_c('span',[_vm._v(_vm._s(_vm.tag))])])])}
var staticRenderFns = []

export { render, staticRenderFns }